/* eslint-disable fp/no-mutation */
/* eslint-disable fp/no-unused-expression */
/* eslint-disable fp/no-nil */

let copyToClipboard = async (str: string): Promise<void> => {
  await navigator.clipboard.writeText(str)
}

export default copyToClipboard
